"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isNonEmptyString = function (value) { return typeof value === 'string' && value !== ''; };
function getRequestContextQuery(requestContext) {
    if (!requestContext) {
        return '';
    }
    var buildForSiteOwnerQuery = function (_a) {
        var _b = _a.forSiteOwner, forSiteOwner = _b === void 0 ? null : _b;
        if (!forSiteOwner ||
            !isNonEmptyString(forSiteOwner.loggedInUserId) ||
            !isNonEmptyString(forSiteOwner.siteOwnerId)) {
            return '';
        }
        var forSiteOwnerQuery = '&' +
            ("requestContext.forSiteOwner.loggedInUserId=" + forSiteOwner.loggedInUserId + "&") +
            ("requestContext.forSiteOwner.siteOwnerId=" + forSiteOwner.siteOwnerId);
        return forSiteOwnerQuery;
    };
    var requestContextQuery = buildForSiteOwnerQuery(requestContext);
    return requestContextQuery;
}
exports.getRequestContextQuery = getRequestContextQuery;
//# sourceMappingURL=request-context.js.map